import { CheckOutlined, CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Checkbox, Divider, Form, Input, Modal, Select, Space, Tabs } from "antd"
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components"
// import ImageTabRightImage from "./ImageTabRightImage";
// import ImageTabRightPrompt from "./ImageTabRightPrompt";

const backend = process.env.REACT_APP_BACKEND
const StyledSpace = styled((props)=><Space direction="vertical" size={0} {...props}/>)`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 500px;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-left: 10px;
    overflow: auto;

    & > .ant-space-item .ant-space {
      width: 100%;
    }

    & > .ant-space-item:nth-child(1) {
      text-align: left;
    }

    & > .ant-space-item:nth-child(2) {
      flex-grow: 1;
      display: flex;
      overflow: auto;
    }
  }
`

function GroupTabRight ({rightBox, languageGroup, stateHandler, pageRef}) {
  const ref = useRef()
  const [sourceData, setSourceData] = useState({})
  const [curLanguage, setCurLanguage] = useState("L0010")
  const [fixLanguage, setFixLanguage] = useState(true)
  const [curTitle, setCurTitle] = useState(sourceData.title)

  const getSourceData = () => {
    const code=rightBox[1].code
    const SystemSettingLanguage_code = curLanguage

    axios.get(`${backend}/contents/word_dictionary/group/list/detail/${code}/${SystemSettingLanguage_code}`)
    .then(res=>{
      const newSource = {
        code: rightBox[1].code,
        SystemSettingLanguage_code: curLanguage,
        title: res.data.data[0]?.title
      }
      setSourceData(newSource)
    })
    .catch(err=>{
      console.log(err)
    })
  }
  
  const resetHandler = () => {
    ref.current.resetFields()
  }

  const saveHandler = async() => {
    const value = await ref.current.validateFields()

    axios.post(`${backend}/contents/word_dictionary/group/list/detail`,{value})
    .then(res=>{
      Modal.success({
        title:"수정 완료",
        content: "정상적으로 수정 되었습니다.",
        okText:"확인"
      })
      stateHandler("reRender")
    })
    .catch(err=>{
      console.log(err)
    })
  }

  //pre버튼 클릭 시 함수
  const preRecordHandler = () => {
    stateHandler("rowIndex-", rightBox[1].indexNumber)
  }

  //next버튼 클릭 시 함수
  const nextRecordHandler = () => {
    stateHandler("rowIndex+", rightBox[1].indexNumber)
  }

  const cancelHandler = () => {
    stateHandler("rightBox", [false,{}])
    stateHandler("rowIndex", null)
  }

  useEffect(()=>{
    if(rightBox[1]?.code) {
      if(!pageRef.current) {
        if(!fixLanguage && curLanguage !== "L0010" && rightBox[1].code !== sourceData.code) {
          setCurLanguage("L0010")
        } else {
          getSourceData()
        }
      }
    }
  },[rightBox])

  useEffect(()=>{
    getSourceData()
  },[curLanguage])

  useEffect(()=>{
    ref.current.resetFields()
    setCurTitle(sourceData.title)
  },[sourceData])

  return (
    <div>
      <StyledSpace>
        <Space direction="vertical" size={0}>
          <Space size={0} style={{padding:"6px 6px 6px 10px", fontSize:"15px", fontWeight:"500"}}>번역</Space>
          <Divider style={{display:"flex", margin:"0px"}}/>
        </Space>
        
        <Space direction="vertical" size={0} style={{padding: "10px"}}>
          <Form 
            layout="vertical" 
            ref={ref} 
            initialValues={sourceData}
          >
            <Form.Item name="code" label="코드" hidden style={{margin: "0px 0px 10px"}}>
              <Input></Input>
            </Form.Item>

            <Space>
              <Form.Item name="SystemSettingLanguage_code" style={{margin: "0px 0px 10px"}}>
                <Space>
                  <Select options={languageGroup} defaultValue={curLanguage} onChange={(value)=>setCurLanguage(value)} style={{width:"200px", textAlign:"left"}}></Select>
                </Space>
              </Form.Item>
              <Checkbox style={{height:"30px"}} defaultChecked={fixLanguage} onChange={()=>setFixLanguage(!fixLanguage)}>언어 고정</Checkbox>
            </Space>

            <Form.Item 
              name="title" 
              label="그룹 제목" 
              style={{margin: "0px 0px 10px", textAlign:"left"}}
              rules={[
                {required: true, message:"필수 입력값입니다."}
              ]}
            >
              <Input onChange={(e)=>{setCurTitle(e.target.value)}}></Input>
            </Form.Item>
          </Form>
        </Space>

        <Space direction="vertical" size={0}>
          <Divider style={{display:"flex", margin:"0px"}}/>
          <Space size={0} style={{padding:"10px 6px 6px 6px", width:"100%", justifyContent:"space-between"}}>
            <Button onClick={resetHandler}>내용 초기화</Button>
            <Space>
              <Button onClick={preRecordHandler}><LeftOutlined/>이전</Button>
              <Button type="primary" disabled={curTitle === sourceData.title} onClick={saveHandler}><CheckOutlined/>수정</Button>
              <Button onClick={nextRecordHandler}><RightOutlined/>다음</Button>
              <Button onClick={cancelHandler}><CloseOutlined/>취소</Button>
            </Space>
          </Space>
        </Space>

      </StyledSpace>
    </div>
  )
}

export default GroupTabRight